import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { usersList as _usersList, disableUser as _disableUser, queryUsers as _queryUsers, userAdd as _userAdd, queryupUser as _queryupUser, upUser as _upUser, delUser as _delUser, userGame as _userGame, PostuserGame as _PostuserGame } from "@/api/user";
import { rolesList as _rolesList, queryAdd as _queryAdd, roleAdd as _roleAdd, disableRole as _disableRole, delRole as _delRole, queryupRole as _queryupRole, upRole as _upRole, routesList as _routesList, addRouter as _addRouter, queryupRoute as _queryupRoute, updataRoute as _updataRoute, delRoute as _delRoute, queryFisetRouter as _queryFisetRouter, getAllRouter as _getAllRouter } from "@/api/role";
export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {},
    name: "",
    avatar: "",
    introduction: "",
    roles: [],
    GMauthority: [],
    // 海盗环境
    useryjenv: [],
    // 御剑环境
    is_show_home: "",
    isOverview: false,
    game_show_type: ""
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    usersList: function usersList(_ref, data) {
      var commit = _ref.commit;
      return new Promise(function (resolve, reject) {
        _usersList(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    disableUser: function disableUser(_ref2, data) {
      var commit = _ref2.commit;
      return new Promise(function (resolve, reject) {
        _disableUser(data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    queryUsers: function queryUsers(_ref3, data) {
      var commit = _ref3.commit;
      return new Promise(function (resolve, reject) {
        _queryUsers(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    userAdd: function userAdd(_ref4, data) {
      var commit = _ref4.commit;
      return new Promise(function (resolve, reject) {
        _userAdd(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    queryupUser: function queryupUser(_ref5, data) {
      var commit = _ref5.commit;
      return new Promise(function (resolve, reject) {
        _queryupUser(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    upUser: function upUser(_ref6, data) {
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        _upUser(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    delUser: function delUser(_ref7, data) {
      var commit = _ref7.commit;
      return new Promise(function (resolve, reject) {
        _delUser(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    userGame: function userGame(_ref8, data) {
      var commit = _ref8.commit;
      return new Promise(function (resolve, reject) {
        _userGame(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    PostuserGame: function PostuserGame(_ref9, data) {
      var commit = _ref9.commit;
      return new Promise(function (resolve, reject) {
        _PostuserGame(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    rolesList: function rolesList(_ref10, data) {
      var commit = _ref10.commit;
      return new Promise(function (resolve, reject) {
        _rolesList(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    queryAdd: function queryAdd(_ref11, data) {
      var commit = _ref11.commit;
      return new Promise(function (resolve, reject) {
        _queryAdd(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    roleAdd: function roleAdd(_ref12, data) {
      var commit = _ref12.commit;
      return new Promise(function (resolve, reject) {
        _roleAdd(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    disableRole: function disableRole(_ref13, data) {
      var commit = _ref13.commit;
      return new Promise(function (resolve, reject) {
        _disableRole(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    delRole: function delRole(_ref14, data) {
      var commit = _ref14.commit;
      return new Promise(function (resolve, reject) {
        _delRole(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    queryupRole: function queryupRole(_ref15, data) {
      var commit = _ref15.commit;
      return new Promise(function (resolve, reject) {
        _queryupRole(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    upRole: function upRole(_ref16, data) {
      var commit = _ref16.commit;
      return new Promise(function (resolve, reject) {
        _upRole(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getAllRouter: function getAllRouter(_ref17, data) {
      var commit = _ref17.commit;
      return new Promise(function (resolve, reject) {
        _getAllRouter(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    routesList: function routesList(_ref18, data) {
      var commit = _ref18.commit;
      return new Promise(function (resolve, reject) {
        _routesList(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    addRouter: function addRouter(_ref19, data) {
      var commit = _ref19.commit;
      return new Promise(function (resolve, reject) {
        _addRouter(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    queryupRoute: function queryupRoute(_ref20, data) {
      var commit = _ref20.commit;
      return new Promise(function (resolve, reject) {
        _queryupRoute(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    updataRoute: function updataRoute(_ref21, data) {
      var commit = _ref21.commit;
      return new Promise(function (resolve, reject) {
        _updataRoute(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    delRoute: function delRoute(_ref22, data) {
      var commit = _ref22.commit;
      return new Promise(function (resolve, reject) {
        _delRoute(data).then(function (response) {
          // const { data } = response
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    queryFisetRouter: function queryFisetRouter(_ref23, data) {
      var commit = _ref23.commit;
      return new Promise(function (resolve, reject) {
        _queryFisetRouter(data).then(function (response) {
          var data = response.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 获取用户信息
    getInfor: function getInfor(_ref24) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, state, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref24.commit, state = _ref24.state;
                _context.next = 3;
                return getInfo(state.token);

              case 3:
                data = _context.sent;
                return _context.abrupt("return", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setGMauthority: function setGMauthority(_ref25, GMauthority) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref25.state, dispatch = _ref25.dispatch;
                // store 赋值
                state.GMauthority = GMauthority; // 持久化

                _context2.next = 4;
                return dispatch("d2admin/db/set", {
                  dbName: "sys",
                  path: "user.GMauthority",
                  value: GMauthority,
                  user: true
                }, {
                  root: true
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    setHomeShow: function setHomeShow(_ref26, data) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref26.state, dispatch = _ref26.dispatch;
                // store 赋值
                state.is_show_home = data; // 持久化

                _context3.next = 4;
                return dispatch("d2admin/db/set", {
                  dbName: "sys",
                  path: "user.is_show_home",
                  value: data,
                  user: true
                }, {
                  root: true
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    gameShowType: function gameShowType(_ref27, data) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = _ref27.state, dispatch = _ref27.dispatch;
                state.game_show_type = data;
                _context4.next = 4;
                return dispatch("d2admin/db/set", {
                  dbName: "sys",
                  path: "user.game_show_type",
                  value: data,
                  user: true
                }, {
                  root: true
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    set: function set(_ref28, info) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = _ref28.state, dispatch = _ref28.dispatch;
                // store 赋值
                state.info = info; // 持久化

                _context5.next = 4;
                return dispatch("d2admin/db/set", {
                  dbName: "sys",
                  path: "user.info",
                  value: info,
                  user: true
                }, {
                  root: true
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load: function load(_ref29) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                state = _ref29.state, dispatch = _ref29.dispatch;
                _context6.next = 3;
                return dispatch("d2admin/db/get", {
                  dbName: "sys",
                  path: "user.GMauthority",
                  defaultValue: [],
                  user: true
                }, {
                  root: true
                });

              case 3:
                state.GMauthority = _context6.sent;
                _context6.next = 6;
                return dispatch("d2admin/db/get", {
                  dbName: "sys",
                  path: "user.useryjenv",
                  defaultValue: [],
                  user: true
                }, {
                  root: true
                });

              case 6:
                state.useryjenv = _context6.sent;
                _context6.next = 9;
                return dispatch("d2admin/db/get", {
                  dbName: "sys",
                  path: "user.is_show_home",
                  defaultValue: "",
                  user: true
                }, {
                  root: true
                });

              case 9:
                state.is_show_home = _context6.sent;
                _context6.next = 12;
                return dispatch("d2admin/db/get", {
                  dbName: "sys",
                  path: "user.game_show_type",
                  defaultValue: "",
                  user: true
                }, {
                  root: true
                });

              case 12:
                state.game_show_type = _context6.sent;
                _context6.next = 15;
                return dispatch("d2admin/db/get", {
                  dbName: "sys",
                  path: "user.info",
                  defaultValue: {},
                  user: true
                }, {
                  root: true
                });

              case 15:
                state.info = _context6.sent;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  },
  mutations: {
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_OV: function SET_OV(state, data) {
      state.isOverview = data;
    }
  }
};